<!--CaseItem: 案例子项 2021/01/15 13:54:17 Sunanguang-->

<template>
   <div class="its-case-item" :class="type">
     <template v-if="type==='case'">
        <img :src="getSrc()">
        <div class="its-info">
          <div class="its-title" :title="item.title">{{item.title}}</div>
          <div class="its-desc">{{item.desc}}</div>
          <a class="its-learn-more" :href="item.url" target="_blank">了解详情></a>
        </div>
     </template>
     <div v-else class="its-cover">
       <p class="its-title">获取更多精彩案例内容</p>
       <p class="its-desc">立即关注</p>
       <div class="its-qrcodes">
         <div class="its-qrcode">
           <img src="../../../../assets/images/ekt.png">
           <p>订阅号</p>
         </div>
         <div class="its-qrcode">
           <img src="../../../../assets/images/video.png">
           <p>视频号</p>
         </div>
       </div>
       <button class="its-apply" @click="toDetial('/apply/submit')">试用申请 >></button>
     </div>
   </div>
</template>
<script>
export default {
  name: 'CaseItem',
  props: {
    type: {
      type: String,
      default: 'case'
    },
    item:  {
      type: Object,
      default: function () {
          return {}
      }
    }
  },
  data () {
       return {
        tip: 'Hi, 新的组件'
       }
  },
  methods: {
    getSrc: function () {
      return require('@/assets/images/case' + this.item.id + '.png')
    },
    toDetial:function(url){
      // document.body.scrollTop = document.documentElement.scrollTop = 0
      // this.$router.push(url)
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.its-case-item {
  width: 310px;
  height: 354px;
  margin-left: 106px;
  margin-bottom: 40px;
  display: inline-block;
  border-radius: 12px;
  font-family: 'MicrosoftYaHei';
  overflow: hidden;
}

.its-case-item.more {
  background-image: url(../../../../assets/images/learn_more_bg.png);
  background-repeat: no-repeat;
  background-size: 310px 354px;
}

.its-case-item.more .its-cover {
  background-color: rgba(0, 0, 0, 0.65);
  width: 100%;
  height: 100%;
  text-align: center;
}

.its-case-item img {
  width: 310px;
  height: 184px;
}

.its-info {
  height: 170px;
  position: relative;
  padding: 10px 30px 20px 30px;
  background: white;
}

.its-info .its-title {
  margin-top: 2px;
  font-size: 22px;
  color: #333333;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.its-info .its-desc {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 18px;
  line-height: 1.7;
}

.its-info a {
  width: 112px;
  height: 30px;
  line-height: 30px;
  border-radius: 14px;
  background-color: #4D9DF4;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  margin: 0 auto;
  cursor: pointer;
  color: white;
  font-size: 16px;
  text-align: center;
}

.its-info a:hover {
  opacity: 0.8;
}

.its-case-item.more .its-cover .its-title {
  font-size: 18px;
  text-align: center;
  color: white;
  padding-top: 22px;
}

.its-case-item.more .its-cover .its-desc {
  font-size: 24px;
  text-align: center;
  color: white;
  padding-top: 9px;
}

.its-qrcodes {
  text-align: center;
  margin-top: 24px;
}

.its-qrcode {
  display: inline-block;
  margin-left: 19px;
}

.its-qrcode img {
  width: 113px;
  height: 113px;
}

.its-qrcode p {
  margin-top: 11px;
  color: white;
  font-size: 18px;
  text-align: center;
}

.its-qrcode:first-child {
  margin-left: 0;
}

.its-apply {
  width: 245px;
  height: 38px;
  line-height: 36px;
  background-image: linear-gradient(180deg, #E3BF79 0%, #DF9951 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#DF9951, endColorstr=#E3BF79);
  border: none;
  box-shadow: none;
  cursor: pointer;
  color: black;
  font-size: 22px;
  margin: 20px auto 0 auto;
  border-radius: 20px;
}

</style>